import { InjectionToken } from '@angular/core';

/** 지원하는 다국어 목록. 메뉴 오픈 상태에서 표시 */
export const PW_SUPPORTED_LOCALES = new InjectionToken<
  { name: string; value: string }[]
>('PW_SUPPORTED_LOCALES');
